import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/PartsMaster.css";
import Table from "../Homepage/Table";
import AddPartsMaster from "./AddPartsMaster";
import SearchPartsMaster from "./SearchPartsMaster";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function PartsMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const [loading, setloading] = useState(false);
  const tablehead = [
    "Part Id",
    "Part Number",
    "Part Name",
    "Part Description",
    "Category",
    "Subcategory",
    "Units",
    "GST Rate (Percentage)",
    "HSN Code",
    "Selling Price",
    "Weight",
    "Dimensions",
    "Packing",
    "Material of Construction",
    "IBR Certification",
  ];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [partsupdatedata, setpartsupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const formRef = useRef();
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [partId, setPartId] = useState(null);

  useEffect(() => {
    setloading(true);
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/api/v1/Parts/${pagenumber}`,
          {
            Id: partId || null,
            Search: search,
            Ids,
          }
        );

        const tableData = response.data.data.map((part) => [
          part.id,
          part.partNumber,
          part.name,
          part.description,
          part.category?.name,
          part.subCategory?.name,
          part.unit?.name,
          part.gst?.rate ? part.gst?.rate + "%" : "",
          part.hsn?.hsnCode,
          part.sellingPrice,
          part.weight,
          part.dimensions,
          part.packing?.name,
          part.materialOfConstruction,
          part.ibr ? "Yes" : "No",
        ]);
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(tableData);
      } catch (error) {
        console.log(error);
      } finally {
        setloading(false);
      }
    };

    fetchData();
  }, [reload, pagenumber, Ids.length]);

  function fetchpartsdata(partid) {
    setpartsupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Parts/GetPartsByIdAndName?id=${partid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        setpartsupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Parts" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Parts" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Parts" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) => x.head === "Master" && x.subHead === "Parts" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="parts-master">
      <h1>Parts Master</h1>
      <blockquote className="parts-master-forms">
        <AddMaster
          text="Add Parts Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Parts Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddPartsMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          partsupdatedata={partsupdatedata}
          key={`${partsupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchPartsMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setPartId={setPartId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchpartsdata}
        url="Parts/UpdatePart"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default PartsMaster;
